import TableText from "@/components/table/TableText";
import { Button, message, Row, Table, Spin, DatePicker, Select, Radio } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "../../../Auth";
import imgSave from "../../../saveImg";
import { SPR } from "../compute";
import FileSaver from "file-saver";
import request from "@/method/request";
import compute, { setKarte } from "./compute";
import "./index.scss";
import { numConvert } from "../../../../../method";

const { MonthPicker } = DatePicker;
const { Option } = Select

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            lastdata: [],
            loading: true,
            loadingSave: false,
            print: false,
            dateData: [],
            area: "东南华南",
            fullYear: 0
        }
    }


    componentDidMount() {
        this.getData({ date: this.state.date, area: this.state.area, fullYear: 0 });
    }

    setChart = (data, lastData) => {
        const len = data.length - 1;
        const dataX = data.filter((x, i) => i < len).map(x => x.hotel_name);
        setKarte({
            dataY: [data.filter((x, i) => i < len).map(x => (x.occ * 100).toFixed(2)), lastData.filter((x, i) => i < len).map(x => (x.occ * 100).toFixed(2))],
            name: "Occ%",
            dataX,
            id: 'chartOcc',
        });
        setKarte({
            dataY: [data.filter((x, i) => i < len).map(x => numConvert(x.adr).toFixed(2)), lastData.filter((x, i) => i < len).map(x => numConvert(x.adr).toFixed(2))],
            name: "ADR",
            dataX,
            id: 'chartAdr',
        });
        setKarte({
            dataY: [data.filter((x, i) => i < len).map(x => numConvert(x.revpar).toFixed(2)), lastData.filter((x, i) => i < len).map(x => numConvert(x.revpar).toFixed(2))],
            name: "REVPAR",
            dataX,
            id: 'chartRevpar',
        });
        setKarte({
            dataY: [data.filter((x, i) => i < len).map(x => numConvert(x.rev).toFixed(2)), lastData.filter((x, i) => i < len).map(x => numConvert(x.rev).toFixed(2))],
            name: "ROOM REVENUE",
            dataX,
            id: 'chartRoomRev',
        });
        this.setState({ data, lastData });
    }


    getData = async ({ date, area, fullYear }) => {
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            const res = await request(`/_4_2_daily/summary?year=${year}&month=${month}&area=${area}&fullYear=${fullYear}`);
            this.setChart(compute(res.data.data || []), compute(res.data.lastdata || []));
            this.setState({ loading: false, });
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    }


    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_2_2', 1.5, '4.22', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }
    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} Daily Report 区域报表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }
    render() {
        const { print, loading, data, date, fullYear, area } = this.state;
        const columns = [{
            title: 'Hotel',
            dataIndex: 'hotel_name',
            key: 'hotel_name',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "hotel_name", };
                return <TableText data={props} />
            }
        }, {
            title: 'Available room',
            dataIndex: 'ava',
            key: 'ava',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "ava", };
                return <TableText data={props} />
            }
        }, {
            title: 'Sold Room',
            dataIndex: 'sold',
            key: 'sold',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "sold", };
                return <TableText data={props} />
            }
        }, {
            title: 'Occupancy %',
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'percent', name: "occ", };
                return <TableText data={props} />
            }
        }, {
            title: 'ADR',
            dataIndex: 'adr',
            key: 'adr',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "adr", };
                return <TableText data={props} />
            }
        }, {
            title: 'RevPAR',
            dataIndex: 'revpar',
            key: 'revpar',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "revpar", };
                return <TableText data={props} />
            }
        }, {
            title: 'Room Revenue',
            dataIndex: 'rev',
            key: 'rev',
            width: 100,
            align: "center",
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "rev", };
                return <TableText data={props} />
            }
        }, {
            title: 'Room Revenue %',
            dataIndex: 'revper',
            key: 'revper',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'percent', name: "revper", };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }, {
            title: 'Hotel Total Revenue',
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 100,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "total", };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }];
        let dataSource = [];
        if (moment(date).format('M') == 5 || moment(date).format('M') == 10) {
            // 五一、十一
            dataSource = data.slice(0, 7);
        } else if (SPR[moment(date).format('Y')].m == moment(date).format('M')) {
            // 春节
            const index = SPR[moment(date).format('Y')].d - 1;
            dataSource = data.slice(index, index + 7);
        }
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_6 table4_2_summary" id="table4_2_2" style={{ height: 'auto' }}>
                    <Row className="title">
                        <Row>Daily Report 区域报表</Row>
                        <div className="title-select">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getData({ date: str, area })
                                }}
                            />
                            <Select
                                allowClear
                                defaultValue={area}
                                style={{ width: 200, marginLeft: 20 }}
                                onChange={(value) => {
                                    this.setState({
                                        data: [],
                                        loading: true,
                                        area: value
                                    }, () => {
                                        this.getData({ date, area: value })
                                    });
                                }}
                            >
                                <Option value="东南华南">东南华南</Option>
                                <Option value="华北华中">华北华中</Option>
                                <Option value="江浙沪皖">江浙沪皖</Option>
                                <Option value="西南">西南</Option>
                            </Select>
                            <Radio.Group
                                style={{ marginLeft: 10 }}
                                onChange={e => {
                                    const _fullYear = e.target.value;
                                    this.setState({
                                        data: [],
                                        loading: true,
                                        fullYear: _fullYear
                                    }, () => {
                                        this.getData({ date, area, fullYear: _fullYear })
                                    });
                                }} value={fullYear}>
                                <Radio value={1}>全年</Radio>
                                <Radio value={0}>当月</Radio>
                            </Radio.Group>
                        </div>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table4_2_2_export"
                            pagination={false}
                            className="content"
                            scroll={print ? {} : { y: 500, x: false }}
                            rowKey={(record, index) => record.hotel_name}
                        />
                        <Button
                            type="primary"
                            style={{ float: 'right', marginTop: 20 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={print}
                        >导出Excel</Button>
                    </Row>
                    <Row className="title">
                        <div className="chart-4-2">
                            <div id="chartOcc"></div>
                            <div id="chartAdr"></div>
                            <div id="chartRevpar"></div>
                            <div id="chartRoomRev"></div>
                        </div>
                        <Auth loading={loading} auth="edit_4_2">
                            <Row className="table-footer-btn" style={{ display: print ? 'none' : "" }}>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 10 }}
                                    onClick={this.downloadSG}
                                    loading={print}
                                >加入pdf</Button>
                            </Row>
                        </Auth>

                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/summary/index.js